import { TranslationMap } from '@trimble-gcs/i18n-types';

export function downloadProgressTranslations() {
  return {
    completed: {
      tooltip: {
        text: $localize`:@@downloadProgress.completed.tooltip:Download Completed`,
        desc: 'Tooltip text for the downloaded completed icon.',
      },
    },
    failed: {
      tooltip: {
        text: $localize`:@@downloadProgress.failed.tooltip:Download Failed`,
        desc: 'Tooltip text for the downloaded failed icon.',
      },
    },
  } satisfies TranslationMap;
}
